import { Routes } from '@angular/router';

/**
 * Deployed builds get no development-only routes.
 *
 * Swapped in for `dev-routes.ts` by `angular.json` → `fileReplacements`, which
 * also drops the sandbox module's `import()` and so keeps its fixtures and mock
 * services out of the bundle entirely.
 */
export const DEV_ROUTES: Routes = [];
